import React from 'react';

interface Props {
  isMobile?: boolean;
}

const BellOff: React.FC<Props> = ({ isMobile }) =>
  isMobile ? <SmallIcon /> : <MediumIcon />;

const SmallIcon = () => (
  <svg width="16" height="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.325 12.873c-.431.789-1.054 1.206-1.84.92-.784-.285-.996-1.006-.826-1.89l-4.515-1.644a.979.979 0 0 1 .67-1.84v.001c1.743-4.89 4.118-7.258 7.108-6.705l.026-.07a.978.978 0 1 1 1.838.669l-.03.084c2.576 1.522 2.89 4.855 1.168 9.703h.001a.979.979 0 0 1-.67 1.84l-2.93-1.068zm1.762-1.441c1.591-4.45 1.18-6.86-.93-7.629-2.105-.766-3.932.824-5.505 5.286l6.435 2.343z"
      fillRule="evenodd"
    />
  </svg>
);

const MediumIcon = () => (
  <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.705 8.769c-.396-1.114-1.234-1.948-2.435-2.41-1.08-.415-2.158-.408-3.116.01-1.137.498-2.064 1.538-2.607 2.954-.7 1.832-1.41 2.662-2.871 3.43-.522.276-.539.29-.602.46a.493.493 0 00.033.401.787.787 0 00.418.368l10.156 3.91a.778.778 0 00.583 0 .457.457 0 00.267-.265c.065-.172.062-.197-.14-.747-.572-1.557-.548-2.644.153-4.476.488-1.275.54-2.566.161-3.635zm-8.58 8.412l-3.337-1.286a2.84 2.84 0 01-1.5-1.342 2.55 2.55 0 01-.128-2.066c.279-.738.642-1.063 1.565-1.55 1.009-.531 1.386-.97 1.912-2.35.733-1.908 2.036-3.37 3.7-4.098a5.92 5.92 0 013.623-.354l.169-.408c.217-.55.764-.85 1.371-.678.607.172.951.872.734 1.422l-.195.474a5.917 5.917 0 012.593 3.135c.55 1.553.478 3.344-.178 5.059-.527 1.378-.54 1.952-.144 3.03.358.973.41 1.46.13 2.193a2.497 2.497 0 01-1.359 1.41 2.815 2.815 0 01-2.133.035l-1.104-.424c-.701 1.317-2.327 1.956-3.808 1.436-1.543-.54-2.367-2.141-1.91-3.638zm1.942.747a.992.992 0 00.674 1.025c.429.15.894.01 1.162-.318l-1.836-.707z"
      fillRule="evenodd"
    />
  </svg>
);

BellOff.displayName = 'BellOff';
export default BellOff;
